import React from "react";
import { Button } from "@mantine/core";
import "./ExamCard.css";
import moment from "moment/moment";
import { useNavigate } from "react-router";
import DecorativeEmptyCircle from "../DecorativeEmptyCircle/DecorativeEmptyCircle";
import showNotification from "../../utils/showNotification";
import { useConfigContext } from "../../contexts/ConfigContext/ConfigContextProvider";

const ExamCard = ({ lesson, title }) => {

   const { jsonTexts, jsonFeatures } = useConfigContext()
  const texts = jsonTexts?.courseView?.examCard
  const {showDecorativeCircle} = jsonFeatures?.pages

  const navigate = useNavigate();
  const currentDate = moment();
  const examInitDate = moment(lesson.data.initDate);

  const isExamAvailable = examInitDate <= currentDate;

  const handleOnClick = () => {
    if (isExamAvailable) {
      navigate(
        `/campus/antes-de-evaluar/${encodeURIComponent(title)}/${
          lesson.data._id
        }`
      );
    } else {
      showNotification({
        color: "yellow",
        status: "warning",
        title:
          "Parece que aún no es la fecha del examen. Podrás ingresar ese mismo día.",
      });
    }
  };

  return (
    <div
      className="coursesCards-exam-father-div"
      key={lesson.data._id}
      onClick={() => handleOnClick()}
    >
      {showDecorativeCircle && <>
         <DecorativeEmptyCircle
        size={200}
        opacity={0.5}
        top={-100}
        left={780}
        color="var(--color-tertiary-dark)"
        borderWidth={32}
        zIndex={-1}
      />
      <DecorativeEmptyCircle
        size={130}
        opacity={0.5}
        top={-60}
        left={300}
        color="var(--color-tertiary-dark)"
        borderWidth={32}
        zIndex={-1}
      />
      </>}
      <div className="coursesCards-exam-div-date">
        <span className="coursesCards-exam-text-span-date">{texts?.label}</span>
        <span className="coursesCards-exam-span-date">
          {moment(lesson.data.initDate).format("DD/MM")}
        </span>
      </div>
      <div className="coursesCards-exam-description-color">
        <p className="coursesCards-exam-description">{lesson.data.name}</p>
        <div className="coursesCards-exam-buttons-div">
          <Button
            fw="normal"
            color="var(--color-tertiary-dark)"
            disabled={!isExamAvailable}
            onClick={() =>
              navigate(
                `/campus/antes-de-evaluar/${encodeURIComponent(title)}/${
                  lesson.data._id
                }`
              )
            }
          >
            {texts?.buttonText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ExamCard;
